
export const UtilUrl = () => {

  const url: { [key: number]: { pathLambda: string; pathLambdaProxy: string; } } = {
    1: {
      pathLambda: '/uadmin/registra-solicitud',
      pathLambdaProxy: '/service/uadmin/registraSolicitud'
    },
    2: {
      pathLambda: '/uadmin/login-app',
      pathLambdaProxy: '/service/uadmin/loginApp'
    },
    3: {
      pathLambda: '/uadmin/activacion-usuario-app',
      pathLambdaProxy: '/service/uadmin/activacionUsuarioApp'
    },
    4: {
      pathLambda: '/uadmin/get-usuarios-app',
      pathLambdaProxy: '/service/uadmin/getUsuariosApp'
    },
    5: {
      pathLambda: '/uadmin/actualiza-usuario-app',
      pathLambdaProxy: '/service/uadmin/actualizaUsuarioApp'
    },
    6: {
      pathLambda: '/uadmin/registra-usuario-app',
      pathLambdaProxy: '/service/uadmin/registroUsuarioApp'
    },
    7: {
      pathLambda: '/uadmin/actualiza-contrasenia-app',
      pathLambdaProxy: '/service/uadmin/actualizaContraseniaApp'
    },
    8: {
      pathLambda: '/uadmin/get-solicitudes-app',
      pathLambdaProxy: '/service/uadmin/getSolicitudesApp'
    },
    9: {
      pathLambda: '/uadmin/elimina-usuario-app',
      pathLambdaProxy: '/service/uadmin/eliminaUsuarioApp'
    },
    10: {
      pathLambda: '/uadmin/get-solicitud-app',
      pathLambdaProxy: '/service/uadmin/getSolicitudApp'
    },
    11: {
      pathLambda: '/uadmin/eliminar-solicitud',
      pathLambdaProxy: '/service/uadmin/eliminarSolicitud'
    },
    12: {
      pathLambda: '/uadmin/obtener-documento',
      pathLambdaProxy: '/service/uadmin/obtenerDocumento'
    },
    13: {
      pathLambda: '/uadmin/control-registro-beneficiarios',
      pathLambdaProxy: '/service/uadmin/controlRegistroBeneficiarios'
    },
    14: {
      pathLambda: '/uadmin/registrar-departamento',
      pathLambdaProxy: '/service/uadmin/registrarDepartamento'
    },
    15: {
      pathLambda: '/uadmin/get-departamentos',
      pathLambdaProxy: '/service/uadmin/getDepartamentos'
    },
    16: {
      pathLambda: '/uadmin/registra-municipio',
      pathLambdaProxy: '/service/uadmin/registrarMunicipio'
    },
    17: {
      pathLambda: '/uadmin/get-municipios',
      pathLambdaProxy: '/service/uadmin/getMunicipios'
    },
    18: {
      pathLambda: '/uadmin/ejecuta-evento-estado',
      pathLambdaProxy: '/service/uadmin/ejecutaEventoyEstado'
    },
    19: {
      pathLambda: '/uadmin/registra-beneficiario-solicitud',
      pathLambdaProxy: '/service/uadmin/registraBeneficiarioSolicitud'
    },
    20: {
      pathLambda: '/uadmin/elimina-beneficiario-solicitud',
      pathLambdaProxy: '/service/uadmin/eliminaBeneficiarioSolicitud'
    },
    21: {
      pathLambda: '/uadmin/get-beneficiarios-solicitud',
      pathLambdaProxy: '/service/uadmin/getBeneficiariosSolicitud'
    },
    22: {
      pathLambda: '/uadmin/actualiza-solicitud',
      pathLambdaProxy: '/service/uadmin/actualizaSolicitud'
    },
    23: {
      pathLambda: '/uadmin/get-confirguracion-envio-notificaciones',
      pathLambdaProxy: '/service/uadmin/getConfirguracionEnvioNotificaciones'
    },
    24: {
      pathLambda: '/uadmin/actualiza-configuracion-envio-notificaciones',
      pathLambdaProxy: '/service/uadmin/actualizaConfiguracionEnvioNotificaciones'
    },
    25: {
      pathLambda: '/uadmin/get-municipios-por-departamento',
      pathLambdaProxy: '/service/uadmin/getMunicipiosPorDepartamento'
    },
    26: {
      pathLambda: '/uadmin/eliminar-municipio-departamento',
      pathLambdaProxy: '/service/uadmin/eliminarMunicipioDepartamento'
    },
    27: {
      pathLambda: '/uadmin/elimina-registro-s3',
      pathLambdaProxy: '/service/uadmin/eliminaRegistroS3'
    },
    28: {
      pathLambda: '/uadmin/obtener-data-excel',
      pathLambdaProxy: '/service/uadmin/obtenerDataExcel'
    },
    29: {
      pathLambda: '/uadmin/get-url-prefirmada',
      pathLambdaProxy: '/service/uadmin/getUrlPrefirmada'
    },
    30: {
      pathLambda: '/uadmin/agrega-comentario',
      pathLambdaProxy: '/service/uadmin/agregaComentario'
    }
  }

  return {
    actionRoute: 'LOCAL', // LOCAL, LAMBDA o PROXY
    url,
    urlEntornoLocal: '',
    urlDominioServidor: '',
    urlEntornoLambdaProxy: '',
    urlEntornoLambda: '',
  }

}

